import { CoreAPI } from '../../core';
import { getEditorOperateState } from '../states/editor-operate-state';
import { IGlobalMask } from '../type';

/** 全局遮罩 */
export class GlobalMask {
    constructor(private readonly identity: string) {}

    /** 显示全局遮罩 */
    show(args: IGlobalMask) {
        getEditorOperateState(this.identity).setGlobalMask(args);
        CoreAPI(this.identity).events.emitGlobalMask({
            isShow: true,
            isHide: false,
            zIndex: 1010,
            data: args,
        });
    }

    /** 隐藏全局遮罩 */
    hide() {
        getEditorOperateState(this.identity).setGlobalMask(null);
        CoreAPI(this.identity).events.emitGlobalMask({
            isShow: false,
            isHide: true,
            zIndex: 0,
            data: null,
        });
    }

    /** 监听全局遮罩 */
    onMask(
        callback: (args: { isShow: boolean; isHide: boolean; zIndex: number; data: IGlobalMask }) => void,
        weight = 0,
    ) {
        return CoreAPI(this.identity).events.onGlobalMask(callback, weight);
    }
}
